
($ => {
  $(document).on('gform_post_render', function (event, formId) {
    const formSelectionButtons = document.querySelectorAll('.form-selection-button.button');

    formSelectionButtons.forEach(button => {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        const selectOption = this.dataset.selectOption;

        if (!selectOption) {
          console.warn('Form Selection Button: Missing selectOption data attribute');
          return;
        }

        const allForms = document.querySelectorAll('.gform_wrapper form, .gform_wrapper.gravity-theme form');
        let targetForm = null;

        for (let form of allForms) {
          const selectElements = form.querySelectorAll('select');
          for (let selectElement of selectElements) {
            const optionByValue = selectElement.querySelector(`option[value="${selectOption}"]`);
            if (optionByValue) {
              targetForm = form;
              break;
            }
          }
          if (targetForm) break;
        }

        if (targetForm) {
          targetForm.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });

          selectFormOption(targetForm, selectOption);
        } else {
          console.warn(`Form Selection Button: No form found with select option "${selectOption}"`);
        }
      });
    });

    function selectFormOption(formElement, selectOption) {
      const selectElements = formElement.querySelectorAll('select');

      if (selectElements.length === 0) {
        console.warn('Form Selection Button: No select elements found in form');
        return;
      }

      selectElements.forEach(selectElement => {
        const optionByValue = selectElement.querySelector(`option[value="${selectOption}"]`);
        if (optionByValue) {
          selectElement.value = selectOption;
          triggerChangeEvent(selectElement);
          return;
        }

        const options = selectElement.querySelectorAll('option');
        for (let option of options) {
          if (option.textContent.trim() === selectOption) {
            selectElement.value = option.value;
            triggerChangeEvent(selectElement);
            return;
          }
        }
      });
    }

    function triggerChangeEvent(element) {
      const event = new Event('change', { bubbles: true });
      element.dispatchEvent(event);

      const inputEvent = new Event('input', { bubbles: true });
      element.dispatchEvent(inputEvent);
    }
  });
})(jQuery);
